<template>
  <report-mobile-shift-rows
    :loading="loading.getDailyRestaurant"
    :rows="shiftRows"
    :stats="stats"
    :search="filters.search"
    empty-icon="mdi-pot-steam-outline"
  ></report-mobile-shift-rows>
</template>

<script>
import ReportMealsTabFoods from "@/components/report/meals/tabs/ReportMealsTabFoods.vue";
import { SHIFTS } from "@/constants/shifts";
import hasShiftRows from "../../shared/hasShiftRows";
import ReportMobileShiftRows from "../ReportMobileShiftRows.vue";

/**
 * Mobilni prikaz "Jela" (pojedinačna jela koja se pripremaju): spisak po abecedi sa ukupnim brojem porcija i
 * brojem po smeni. Pretraga je u lupi zaglavlja. Nasleđuje učitavanje, štampu i Excel iz ReportMealsTabFoods.
 */
export default {
  name: "ReportMobileFoods",
  extends: ReportMealsTabFoods,
  mixins: [hasShiftRows],
  components: { ReportMobileShiftRows },
  computed: {
    shiftItems() {
      return this.foods;
    },
    /** Porcije svih obroka u izveštaju (jedan obrok može imati više jela). */
    mealPortions() {
      return SHIFTS.reduce((sum, shift) => {
        const meals = this.report?.[`${shift.id}-smena`] || {};
        return sum + Object.values(meals).reduce((total, meal) => total + (Number(meal.quantity) || 0), 0);
      }, 0);
    },
    stats() {
      return [
        { key: "foods", label: this.$t("meals_main"), value: this.foods.length },
        { key: "meals", label: this.$t("report_desktop.total_meals"), value: this.mealPortions },
      ];
    },
  },
};
</script>
